import BaseModel from '../../base';

export default class Variable extends BaseModel {
  constructor(item = {}, url) {
    super(item, url);

    this.name = item.name;
  }
}
